import antd from 'ant-design-vue/es/locale/zh_CN'

import { flattenMap } from '@/utils/locale'
import layout from './zh-CN/layout'
import okr from './zh-CN/okr'
import guide from './zh-CN/guide'
import shared from './zh-CN/shared'
import bestCase from './zh-CN/best-case'
import changelog from './zh-CN/changelog'
import statistic from './zh-CN/statistic'
import weekly from './zh-CN/weekly'

const components = {
  antLocale: antd
}

export default {
  ...components,
  ...flattenMap({
    layout,
    okr,
    guide,
    shared,
    weekly
  }),
  bestCase,
  changelog,
  statistic
}
